module.exports = __webpack_public_path__ + "img/logo_kitkitphase3@0.5x-300x169.9ca23168.png";